document.addEventListener('alpine:init', () => {
  Alpine.data('countryIntro', () => ({
    buttons: [],

    init() {
      document.querySelectorAll('.block[id] h2').forEach((heading) => {
        const title = heading.textContent;
        const contentBlock = this.findParentContentBlock(heading);

        if (title && contentBlock?.id) {
          this.buttons.push({
            href: `#${contentBlock.id}`,
            text: title,
          });
        }
      });
    },

    findParentContentBlock(section) {
      let parent = section.parentElement;

      while (parent && parent.tagName !== 'BODY') {
        if (parent.classList.contains('block')) {
          return parent;
        }

        parent = parent.parentElement;
      }

      return null;
    },
  }));
});